import logger from '../../services/logger';

import React, { useCallback, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import PanneAndDeviceCreate from './PanneAndDeviceCreate'
//import TroubleShootChatbot from './TroubleShoot';
//import VoiceChatbot from './VoiceChatbot';
//import OrchesChatbot from './OrchesChatbot';
import AnimChatbotGen from "./AnimChatbotGen";
import configChatbotRepair from "./configChatbotRepair.json";
import {
  repairChatbotActions,
  repairChatbotLogic,
} from "./actionChatbotRepair";
import { calculateBonus } from "../tool/BonusRepair";
import chatbotRepairTemplates from "./chatbotRepairTemplates";
import GuaranteeHelpModal from "../common/GuaranteeHelpModal";
import BonusHelpModal from "../common/BonusHelpModal";
import ApplianceScannerModal from "../common/ApplianceScannerModal";
import InvoiceScannerModal from "../common/InvoiceScannerModal";

const RepairPage = () => {

  //const navigate = useNavigate(); // Utilise useNavigate au lieu de useHistory
    

    // Récupérer l'objet univer depuis l'état de location
    const location = useLocation();
    // Récupérer les objets product et event de location.state
    const {product, event } = location.state || {};
    const [productState, setProductState] = useState(product || null);
    const [currentPanne, setCurrentPanne] = useState("");
    const [currentDevice, setCurrentDevice] = useState("");


    const [currentStep, setCurrentStep] = useState(0);
    const [transitionClass, setTransitionClass] = useState('');

    // Vérifier si les objets sont présents
    logger.log("Product:", productState);
    logger.log("Repair Event:", event);
  
    const steps = ['Description','Troubleshooting', 'Solution'];

    const buildRepairChatbotContext = (device, ctxEvent, extra = {}) => {
        const product = device || null;
        const event = ctxEvent || null;
        const productName = product?.prodName || product?.name || "votre appareil";
        const productPict = product?.pict || product?.image || "";
        const productBrand = product?.marque || product?.brand || "-";
        const productModel = product?.modele || product?.model || "-";
        const facture = product?.facture || {};
        const bonus = productName ? calculateBonus(productName) : "Introuvable";
        const hasBonus = bonus !== "Introuvable";
        const hasFacture = Boolean(facture && Object.keys(facture).length);
        const express = true;
        //Boolean(event?.express || product?.express);

        return {
          product,
          event,
          productName,
          productPict,
          productBrand,
          productModel,
          bonus,
          hasBonus,
          facture,
          hasFacture,
          express,
          ...extra,
        };
      };

    
    const getNewPanne = (device, eventPanne) => {
        setCurrentPanne(eventPanne);
        setCurrentDevice(device);
        nextStep();
  
      };
  
      const nextStep = () => {
        setTransitionClass('slide-left'); // Ajoute la classe de transition
        setTimeout(() => {
          setCurrentStep((prev) => Math.min(prev + 1, steps.length));
          setTransitionClass(''); // Retire la classe de transition après le changement de page
        }, 500); // Durée de l'animation en ms (doit correspondre avec le CSS)
      };
      
      /*
      const prevStep = () => {
        if (currentStep === 0) navigate(-1);
        else setCurrentStep((prev) => Math.max(prev - 1, 0));
      };*/
/*
  {currentStep===0 && product.name && <TroubleShootChatbot product={product} event={event} action={getNewPanne}/>}
  {currentStep===1 && product.name && <TroubleShootChatbot product={currentDevice} event={currentPanne} action={getNewPanne}/>}
   
*/
 /*<PageTitle title = {"Réparation"}/>  */     

    const handleApplianceConfirm = useCallback((payload) => {
      setProductState((prev) => {
        const next = { ...(prev || {}) };
        const nextName = payload?.type || payload?.prodName || payload?.name || "";
        if (nextName) {
          next.prodName = nextName;
          next.name = nextName;
        }
        const nextBrand = payload?.marque || payload?.brand || "";
        if (nextBrand) {
          next.marque = nextBrand;
        }
        const nextModel = payload?.modele || payload?.model || "";
        if (nextModel) {
          next.modele = nextModel;
          next.model = nextModel;
        }
        const nextPict = payload?.pict || payload?.image || "";
        if (nextPict) {
          next.pict = nextPict;
          next.image = nextPict;
        }
        return next;
      });
    }, []);

    const mainContext = useMemo(
      () => buildRepairChatbotContext(productState, event),
      [productState, event]
    );
    const secondaryContext = useMemo(
      () => buildRepairChatbotContext(currentDevice, currentPanne),
      [currentDevice, currentPanne]
    );
    const repairPopins = useMemo(
      () => ({
        Guaranteehelp: GuaranteeHelpModal,
        BonusHelp: BonusHelpModal,
        ImageUploader: (props) => (
          <ApplianceScannerModal
            {...props}
            onConfirm={handleApplianceConfirm}
            onPopinConfirm={(payload) => {
              if (props.onPopinConfirm) {
                const nextName =
                  payload?.type || payload?.prodName || payload?.name || "";
                const nextBrand = payload?.marque || payload?.brand || "";
                const nextModel = payload?.modele || payload?.model || "";
                const nextPict = payload?.pict || payload?.image || "";
                props.onPopinConfirm({
                  contextPatch: {
                    productName: nextName || undefined,
                    productBrand: nextBrand || undefined,
                    productModel: nextModel || undefined,
                    productPict: nextPict || undefined,
                  },
                });
              }
            }}
          />
        ),
        InvoiceUploader: (props) => (
          <InvoiceScannerModal
            {...props}
            onConfirm={handleApplianceConfirm}
            onPopinConfirm={(payload) => {
              if (props.onPopinConfirm) {
                const nextName =
                  payload?.type || payload?.prodName || payload?.name || "";
                const nextBrand = payload?.marque || payload?.brand || "";
                const nextModel = payload?.modele || payload?.model || "";
                const nextPict = payload?.pict || payload?.image || "";
                props.onPopinConfirm({
                  contextPatch: {
                    productName: nextName || undefined,
                    productBrand: nextBrand || undefined,
                    productModel: nextModel || undefined,
                    productPict: nextPict || undefined,
                  },
                });
              }
            }}
          />
        ),  
      }),
      [handleApplianceConfirm]
    );
    const hasProductName = Boolean(productState?.name || productState?.prodName);
  return (
    <div>
      

      <div className='col-12'>
        <div className={`step-container ${transitionClass}`}>
        {currentStep===0 && !hasProductName && <PanneAndDeviceCreate action={getNewPanne}/>}
        {/* {currentStep===0 && product?.name && <OrchesChatbot product={product} event={event} action={getNewPanne}/>} */}
        {currentStep===0 && hasProductName && (
          <AnimChatbotGen
            config={configChatbotRepair}
            context={mainContext}
            actions={repairChatbotActions}
            logicGuards={repairChatbotLogic}
            popinComponents={repairPopins}
            templates={chatbotRepairTemplates}
          />
        )}
        {/* {currentStep===1 && product?.name && <OrchesChatbot product={currentDevice} event={currentPanne} action={getNewPanne}/>} */}
        {currentStep===1 && hasProductName && currentDevice && (
          <AnimChatbotGen
            config={configChatbotRepair}
            context={secondaryContext}
            actions={repairChatbotActions}
            logicGuards={repairChatbotLogic}
            popinComponents={repairPopins}
            templates={chatbotRepairTemplates}
          />
        )}
        </div>
      <br/>
      </div>
    </div>
  );
};

export default RepairPage;
